"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var Table_1 = require("@sportnet/ui/lib/Table");

var utilities_1 = require("@sportnet/ui/lib/utilities");

var polished_1 = require("polished");

var React = tslib_1.__importStar(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));

var utilities_2 = require("../../../utilities");

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  th {\n    vertical-align: bottom;\n  }\n"], ["\n  th {\n    vertical-align: bottom;\n  }\n"])));
var TeamName = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n"], ["\n  color: ", ";\n  font-size: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.color.fadedText;
}, polished_1.rem(12));
var StyledTd = styled_components_1["default"](Table_1.Td)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), polished_1.rem(120));

var CompetitionStanding = function (_a) {
  var data = _a.data,
      renderEmpty = _a.renderEmpty;

  if ((!data.competitionId || !data.partId) && renderEmpty) {
    return React.createElement(React.Fragment, null, renderEmpty('competitionStanding'));
  }

  if (data.data) {
    var _b = data.data,
        results = _b.results,
        codelist_1 = _b.codelist,
        settings_1 = _b.settings,
        rounds_1 = _b.rounds;

    var formatPoints_1 = function (value, format) {
      if (!format) {
        return value;
      }

      switch (format) {
        case 'time':
          return utilities_2.formatSecondsToString(value);

        default:
          return value;
      }
    };

    var renderTotalPoints_1 = function (totalPoints) {
      return codelist_1.map(function (i, idx) {
        var points = totalPoints.find(function (p) {
          return p.name === i._id;
        });

        if (points) {
          return React.createElement(StyledTd, {
            key: "td_" + idx + "_" + i._id
          }, formatPoints_1(points.value, i.format));
        }

        return null;
      });
    };

    var renderRoundPoints_1 = function (roundResults) {
      return rounds_1.reduce(function (acc, r) {
        var roundPoints = roundResults.find(function (i) {
          return i.match.round && i.match.round._id === r._id;
        });

        if (!roundPoints) {
          return tslib_1.__spreadArrays(acc, codelist_1.map(function (i) {
            if ((settings_1.roundPoints || []).includes(i._id)) {
              return React.createElement(StyledTd, {
                key: i._id
              });
            }

            return null;
          }).filter(function (i) {
            return i;
          }));
        }

        return tslib_1.__spreadArrays(acc, roundPoints.results.map(function (p, idx) {
          var codelistItem = codelist_1.find(function (c) {
            return c._id === p.name;
          });

          if (codelistItem && (settings_1.roundPoints || []).includes(p.name)) {
            return React.createElement(StyledTd, {
              key: "td_" + idx + "_" + p.name + "_" + p.value
            }, formatPoints_1(p.value, codelistItem.format));
          }

          return null;
        }));
      }, []);
    };

    var renderRoundPointsHeaders = function () {
      if (settings_1.roundPoints && rounds_1.length > 0) {
        return rounds_1.reduce(function (acc, r) {
          if (r) {
            return tslib_1.__spreadArrays(acc, (settings_1.roundPoints || []).map(function (p, idx) {
              var codelistData = codelist_1.find(function (c) {
                return c._id === p;
              });

              if (codelistData) {
                return React.createElement(Table_1.Th, {
                  width: 120,
                  key: "th_" + idx + "_" + r.name
                }, idx === 0 && React.createElement(React.Fragment, null, r.name, React.createElement("br", null)), React.createElement("span", null, codelistData.label));
              }

              return null;
            }).filter(function (i) {
              return i;
            }));
          }

          return acc;
        }, []);
      }

      return null;
    };

    return React.createElement(Wrapper, null, React.createElement(Table_1.Table, null, React.createElement(Table_1.Thead, null, React.createElement(Table_1.Tr, null, React.createElement(Table_1.Th, {
      width: 50
    }), React.createElement(Table_1.Th, null), renderRoundPointsHeaders(), codelist_1.map(function (i, idx) {
      return React.createElement(Table_1.Th, {
        width: 120,
        key: "th_" + idx + "_" + i.label
      }, idx === 0 && React.createElement(React.Fragment, null, utilities_1.__('Celkovo'), React.createElement("br", null)), React.createElement("span", null, i.label));
    }))), React.createElement(Table_1.Tbody, null, results.map(function (result) {
      return React.createElement(Table_1.Tr, {
        key: "tr_" + result.position + "_" + result.players.map(function (p) {
          return p._id;
        }).join(',')
      }, React.createElement(Table_1.Td, null, result.position), React.createElement(Table_1.Td, null, result.players.map(function (p) {
        return p.name;
      }).join(', '), React.createElement("br", null), React.createElement(TeamName, null, result.team.displayName)), renderRoundPoints_1(result.points), renderTotalPoints_1(result.totalPoints));
    }))));
  }

  return null;
};

exports["default"] = CompetitionStanding;
var templateObject_1, templateObject_2, templateObject_3;